import { useDictionary } from '@cvt/hooks/useDictionary';
import { Box, Stack, Typography } from '@mui/material';



export const SpeedUpOnboardingNotice = () => {
  const dictionary = useDictionary();

  return (
    <Box sx={{ height: '100vh', backgroundColor: 'background.default', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Stack
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{ textAlign: 'center', padding: 2 }}
      >
        <Typography variant="h4" fontWeight={500} color="text.primary">
          {dictionary.users.onboarding.appDownloadPrompt}
        </Typography>

      </ Stack>
    </Box>
  );
};

export default SpeedUpOnboardingNotice;
